module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-02.ef8d9051.jpg";